<template>
    <ion-grid class="p-0 max-height purple-purple-color">
        <template v-if="deliveryOptions.length && cartData.supplier.deliveryTiming !== ORDER_DATE.NOTHING">
            <ion-row class="grey4-grey4-background">
                <ion-col class="p-3 fw-b">
                    {{ $t('messages.order.deliveryType') }}
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col class="p-3">
                    <select-simple
						class="unset-max-width"
                        :placeholder="$t('messages.order.deliveryType')"
                        v-model="listStore.order.selectedDeliveryType"
                        @change="changeSettings"
                        :options="deliveryOptions"
                    />
                </ion-col>
            </ion-row>
        </template>

        <!-- TODO: Move to computed variable -->
        <template
            v-if="cartData
        && (cartData.supplier.deliveryTiming === ORDER_DATE.DATE || cartData.supplier.deliveryTiming === ORDER_DATE.DATETIME)
        && listStore.order.selectedDeliveryType === DELIVERY_TYPE.DELIVERY"
        >
            <ion-row class="grey4-grey4-background">
                <ion-col class="p-3 fw-b">
                    {{ $t('messages.order.deliveryTime') }}
                </ion-col>
            </ion-row>

            <template v-if="cartData.supplier.deliveryTiming === ORDER_DATE.DATE">
                <ion-row>
                    <ion-col class="p-3 fw-b">
                        {{ $t('label.date') }}
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col class="px-3 center">
                        <ion-datetime
                            class="grey4-grey4-background custom-datetime"
                            presentation="date"
                            :min="today ?? ''"
                            :max="threeMonthsLater"
                            v-model="listStore.order.deliveryDate"
                            :locale="$i18n.locale"
                            :first-day-of-week="1"
                            :highlighted-dates="highlightDeliveryDays"
                            :is-date-enabled="isScheduled"
                            :key="highlightDeliveryDays.length"
                        >
                            <span slot="time-label">{{ $t('label.time') }}</span>
                        </ion-datetime>
                    </ion-col>
                </ion-row>
            </template>

            <template v-else-if="cartData.supplier.deliveryTiming === ORDER_DATE.DATETIME">
                <ion-row>
                    <ion-col class="p-3 fw-b">
                        {{ $t('label.date') }} {{ $t('label.and') }} {{ $t('label.time') }}
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col class="px-3 center">
                        <ion-datetime
                            class="grey4-grey4-background custom-datetime order-filter-month"
                            presentation="date-time"
                            :min="today ?? ''"
                            :max="threeMonthsLater"
                            v-model="listStore.order.deliveryDate"
                            :highlighted-dates="highlightDeliveryDays"
                            :is-date-enabled="isScheduled"
                            :locale="$i18n.locale"
                            :first-day-of-week="1"
                            :key="highlightDeliveryDays.length"
                        >
                            <span slot="time-label">{{ $t('label.time') }}</span>
                        </ion-datetime>
                    </ion-col>
                </ion-row>
            </template>

            <ion-row v-if="listStore.order.deliveryDate && isOutOfSchedule && !isHolidayDelivery">
                <ion-col class="px-3">
                    <Warning
                        :title="$t('messages.deliveryDayWarningTitle')" :body="$t('messages.deliveryDayWarning')"
                        orange
                    />
                </ion-col>
            </ion-row>

            <ion-row v-if="isHolidayDelivery">
                <ion-col class="px-3">
                    <!-- <div>
                        <div class="fw-b coral-coral-color">
                            {{ $t('messages.holidayDeliveryTitle') }}
                        </div>
                        <div class="fw-b">
                            {{ $t('messages.holidayDelivery') }}
                        </div>
                    </div> -->
                    <Warning :title="$t('messages.holidayDeliveryTitle')" :body="$t('messages.holidayDelivery')" red />
                </ion-col>
            </ion-row>
        </template>

        <template v-else-if="cartData && listStore.order.selectedDeliveryType === DELIVERY_TYPE.PICKUP">
            <ion-row class="grey4-grey4-background">
                <ion-col class="p-3 fw-b">
                    {{ $t('messages.order.pickupTime') }}
                </ion-col>
            </ion-row>
            <ion-row v-if="cartData.supplier.pickupLocations?.length">
                <ion-col class="px-3 pt-3 pb-1">
                    <select-simple
						class="unset-max-width"
                        :placeholder="$t('placeholder.pickupMethod')"
                        v-model="listStore.order.pickupLocation"
                        @change="changeSettings"
                        :options="pickupOptions"
                        :disabled="props.cartData.supplier.pickupLocations?.length === 1"
                    />
                </ion-col>
            </ion-row>

            <template v-if="cartData.supplier.pickupTiming === ORDER_DATE.DATE">
                <ion-row>
                    <ion-col class="p-3 fw-b">
                        {{ $t('label.date') }}
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col class="px-3 center">
                        <ion-datetime
                            class="grey4-grey4-background custom-datetime"
                            presentation="date"
                            :min="today ?? ''"
                            :max="threeMonthsLater"
                            v-model="listStore.order.pickupDate"
                            :locale="$i18n.locale"
                            :first-day-of-week="1"
                            :highlighted-dates="highlightPickupDays"
                            :is-date-enabled="isPickupScheduled"
                            :key="highlightPickupDays.length"
                        >
                            <span slot="time-label">{{ $t('label.time') }}</span>
                        </ion-datetime>
                    </ion-col>
                </ion-row>
            </template>
            <template v-else-if="cartData.supplier.pickupTiming === ORDER_DATE.DATETIME">
                <ion-row>
                    <ion-col class="p-3 fw-b">
                        {{ $t('label.date') }} {{ $t('label.and') }} {{ $t('label.time') }}
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col class="px-3 center">
                        <ion-datetime
                            class="grey4-grey4-background custom-datetime order-filter-month"
                            presentation="date-time"
                            :min="today ?? ''"
                            :max="threeMonthsLater"
                            v-model="listStore.order.pickupDate"
                            :locale="$i18n.locale"
                            :first-day-of-week="1"
                            :highlighted-dates="highlightPickupDays"
                            :is-date-enabled="isPickupScheduled"
                            :key="highlightPickupDays.length"
                        >
                            <span slot="time-label">{{ $t('label.time') }}</span>
                        </ion-datetime>
                    </ion-col>
                </ion-row>
            </template>

            <ion-row v-if="isHolidayPickup">
                <ion-col class="px-3">
                    <Warning :title="$t('messages.holidayPickupTitle')" :body="$t('messages.holidayPickup')" red />
                </ion-col>
            </ion-row>
        </template>

        <template v-if="paymentOptions.length">
            <ion-row class="grey4-grey4-background">
                <ion-col class="p-3 fw-b">
                    {{ $t('messages.order.choosePayment') }}
                </ion-col>
            </ion-row>

            <ion-row>
                <ion-col class="px-3 pt-3 pb-1">
                    <select-simple
						class="unset-max-width"
                        :placeholder="$t('placeholder.paymentMethod')"
                        v-model="listStore.order.paymentMethod"
                        @change="changeSettings"
                        :options="paymentOptions"
                    />
                </ion-col>
            </ion-row>
        </template>

        <ion-row v-if="cartData.supplier.orderHint">
            <ion-col class="p-3 fs-larger">
                {{ $t('label.orderHint') }}: "{{ cartData.supplier.orderHint }}"
            </ion-col>
        </ion-row>

        <template v-if="cartData.supplier.hasCoupon">
            <ion-row class="grey4-grey4-background">
                <ion-col class="p-3 fw-b">
                    {{ $t('messages.order.voucher') }}
                </ion-col>
            </ion-row>

            <ion-row class="mt-2">
                <ion-col class="px-3">
                    <checkbox-simple v-model="redeemVoucher" @change="checkDeleteVoucher">
                        {{ $t('messages.order.redeemVoucher') }}
                    </checkbox-simple>
                </ion-col>
            </ion-row>

            <ion-row v-show="redeemVoucher">
                <ion-col class="px-3">
                    <input-simple
                        v-model="listStore.order.promoCode"
                        :placeholder="$t('messages.order.voucherCode')"
                    />
                </ion-col>
            </ion-row>
        </template>

        <template v-if="cartData.supplier.orderQuestion">
            <ion-row class="my-2">
                <ion-col class="px-3">
                    <checkbox-simple v-model="listStore.order.orderCheckbox">
                        {{ cartData.supplier.orderQuestion }}
                    </checkbox-simple>
                </ion-col>
            </ion-row>
        </template>

        <ion-row v-if="cartData.supplier.allowsOrderMessage" class="pb-2">
            <ion-col class="px-3">
                <textarea-base
                    class="grey4-grey4-background purple-purple-color p-1"
                    :class="{'max-length': Number(listStore.order.orderMessage?.length) >= 255}"
                    style="border-radius: 8px;"
                    lines="none"
                    v-model="listStore.order.orderMessage"
                    :maxlength=255
                    :placeholder="$t('placeholder.sendMessageDeliverer', { deliverer: cartData.supplier.name })"
                    :debounce="250"
                />
                <div class="pt-1 fs-small" v-if="Number(listStore.order.orderMessage?.length) >=255" style="color: var(--ion-color-danger);">
                    {{ $t('error.returnType.OrderMessageTooLong') }}
                </div>
            </ion-col>
        </ion-row>

        <ion-row class="grey4-grey4-background py-2 fs-smaller grey1-grey1-color" style="padding-bottom: 34px;">
            <ion-col size="auto" class="d-flex flex-d-c ion-justify-content-end">
                <ion-row>
                    <ion-col>
                        {{ $t('messages.cart.amountItems', { amount: orderAmountList() }) }}
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col class="py-0 center-y">
                        {{ $t('messages.cart.amount', { amount: amountProducts }) }}
                    </ion-col>
                </ion-row>
            </ion-col>

            <ion-col>
                <div
                    class="ion-justify-content-end d-flex ion-align-items-end flex-d-c"
                    style="gap: 0.5rem; padding-inline: 5px;"
                >
                    <div
                        v-if="cartData.supplier.showCartTotal && summarySum > 0"
                        class="fw-b purple-purple-color fs-larger ion-text-right"
                    >
                        {{ convertNumberWithComma(summarySum.toFixed(3)) }} {{ CURRENCY_EUR }}
                        {{ $t('object.total') }}
                    </div>

                    <button-base
                        class="max-height m-0 wrap-button"
                        style="min-width: 120px;"
                        @click="trackOrder"
                        :disabled="orderDateNotSpecified()"
                    >
                        {{ $t('button.finishOrder') }}
                    </button-base>
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script setup lang="ts">
import { IonCol, IonDatetime, IonGrid, IonRow } from "@ionic/vue";
import { computed, onActivated, onDeactivated, reactive, ref } from "vue";
import { DateTime } from "luxon";

import SelectSimple from "@/components/selects/SelectSimple.vue";
import CheckboxSimple from "@/components/checkbox/CheckboxSimple.vue";
import InputSimple from "@/components/input/InputSimple.vue";
import TextareaBase from "@/components/input/TextareaBase.vue";
import ButtonBase from "@/components/button/ButtonBase.vue";

import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";

import { sameDay } from "@/functions/luxon";

import { CartData, DeliveryDate } from "@/types/supplier";
import {
    DELIVERY_DATE_TYPE,
    ORDER_DATE,
    ORDER_DATE_PICKUP,
    PAYMENT_METHOD,
    PAYMENT_OPTIONS
} from "@/types/enum/supplierEnum";
import { DELIVERY_TYPE } from "@/types/enum/order";
import { DATE_FORMAT } from "@/types/enum/luxonEnum";
import { useI18n } from "vue-i18n";
import { sentryTrack } from "@/plugins/sentry";
import { useUserStore } from "@/stores/user";
import { useRouteParams } from "@/composables/useRouteParams";
import { convertNumberWithComma } from "@/functions/converter";
import { CURRENCY_EUR } from "@/assets/variables";
import Warning from "@/components/warning/Warning.vue";

const props = defineProps<{ cartData: CartData }>()
const emit = defineEmits<{ (e: 'next'): void }>()

// TODO Move to types folder
type IonDateFormattingInfo = {
    textColor: string;
    backgroundColor?: string;
} | {
    textColor?: string;
    backgroundColor: string;
};

type IonHighlightDate = {
    date: string;
    textColor: string;
    backgroundColor: string;
}

const { t } = useI18n()
const listStore = useListStore()
const supplierStore = useSupplierStore()
const highlightDeliveryDays = ref<IonHighlightDate[]>([])
const highlightPickupDays = ref<IonHighlightDate[]>([])
const today = ref(DateTime.now().toString())
const threeMonthsLater = ref(DateTime.now().plus({ months: 3 }).toString());
const voucher = ref<string>('')
const redeemVoucher = ref<boolean>(false)

const { locationId } = useRouteParams()

const greyText = 'rgba(var(--ion-color-purple-rgb), 0.2)'
const palePink = 'rgba(var(--ion-color-coral-rgb), 0.2)'
const pink = 'var(--ion-color-coral)'

// TODO: Add Input validation for order message max length: 255
const paymentOptions = reactive<{ value: PAYMENT_METHOD, text: string }[]>([])
const pickupOptions = reactive<{ value: string, text: string }[]>([])
const deliveryOptions = reactive<{ value: string, text: string }[]>([])

const summarySum = computed(() => props.cartData.summary.reduce((accumulator, currentValue) => {
    return accumulator + ((currentValue.quantity ?? 0) * (currentValue.item.price ?? 0))
}, 0))

const amountProducts = computed<number>(() => {
    let amount = props.cartData.cartItems?.length ?? 0
    if (!props.cartData.lists) return amount
    for (const list of props.cartData.lists) {
        amount += list.cartItems.length
    }
    return amount
})

const isOutOfSchedule = computed<boolean>(() => {
    const supplierInfo = supplierStore.suppliers.data.find((i) => i.id === props.cartData.supplier.id);
    if (!supplierInfo) return false;
    const scheduleDeliveryDays = supplierInfo.deliveryDays;
    if (!scheduleDeliveryDays || !scheduleDeliveryDays?.length) return false;
    const deliveryDay = new Date(String(listStore.order.deliveryDate)).getDay();
    return !scheduleDeliveryDays.includes(deliveryDay);
})

const isHolidayDelivery = computed<boolean>(() => {
    const supplierDates = supplierStore.deliveryDays[props.cartData.supplier.id]

    if (!supplierDates) return false

    const deliveryDate = supplierDates.find(deliveryDate => sameDay(
        String(listStore.order.deliveryDate),
        DateTime.fromFormat(deliveryDate.date, DATE_FORMAT.INPUT)
    ))

    if (!deliveryDate) return false

    return deliveryDate.type === DELIVERY_DATE_TYPE.HOLIDAY
})

const isHolidayPickup = computed<boolean>(() => {
    const supplierDates = supplierStore.pickupDays[props.cartData.supplier.id]

    if (!supplierDates) return false

    const pickupDate = supplierDates.find(pickupDate => sameDay(
        String(listStore.order.pickupDate),
        DateTime.fromFormat(pickupDate.date, DATE_FORMAT.INPUT)
    ))

    if (!pickupDate) return false

    return pickupDate.type === DELIVERY_DATE_TYPE.HOLIDAY
})

const orderDateNotSpecified = (): boolean => {
    //not sure if i need to check this (props.cartData.supplier.deliveryTiming !== ORDER_DATE.NOTHING) too, maybe you can remove it
    const deliveryNotSpecified = listStore.order.selectedDeliveryType === DELIVERY_TYPE.DELIVERY && props.cartData.supplier.deliveryTiming !== ORDER_DATE.NOTHING && !listStore.order.deliveryDate
    const pickupNotSpecified = listStore.order.selectedDeliveryType === DELIVERY_TYPE.PICKUP && props.cartData.supplier.pickupTiming !== ORDER_DATE_PICKUP.UNAVAILABLE && !listStore.order.pickupDate

    return !!(deliveryNotSpecified || pickupNotSpecified);
}

const orderAmountList = (): number => {
    let amount = 0
    for (const noListItem of props.cartData.cartItems) {
        amount += noListItem.quantity
    }
    for (const list of props.cartData.lists) {
        for (const listItem of list.cartItems) {
            amount += listItem.quantity
        }
    }
    return amount
}

const isScheduled = (isoDate: string): boolean => {
    const supplierDates = supplierStore.deliveryDays[props.cartData.supplier.id]

    if (!supplierDates) return true //Fallback if no info is found

    const deliveryDate = supplierDates.find(deliveryDate => sameDay(isoDate, DateTime.fromFormat(deliveryDate.date, DATE_FORMAT.INPUT)))

    if (!deliveryDate) return true //Fallback if no info is found

    return deliveryDate.selectable
}

const isPickupScheduled = (isoDate: string): boolean => {
    const supplierDates = supplierStore.pickupDays[props.cartData.supplier.id]

    if (!supplierDates) return true // fallback if no info is found

    const pickupDate = supplierDates.find(deliveryDate => sameDay(isoDate, DateTime.fromFormat(deliveryDate.date, DATE_FORMAT.INPUT)))

    if (!pickupDate) return true // fallback if no info is found

    return pickupDate.selectable
}

const enablePickup = (): boolean => {
    return !!props.cartData.supplier.pickupLocations?.length
}

const enableDelivery = (): boolean => {
    // return props.cartData.supplier.pickupTiming === ORDER_DATE.NOTHING
    return true
}

const changeSettings = (newValue: DELIVERY_TYPE | PAYMENT_METHOD) => {
    const settings = props.cartData.supplier?.settings ?? {}

    if (newValue === DELIVERY_TYPE.PICKUP) {
        settings.distribution = {
            pickupLocation: props.cartData.supplier.settings?.distribution?.pickupLocation ?? '',
            method: newValue
        }
    } else if (newValue === DELIVERY_TYPE.DELIVERY) {
        settings.distribution = {
            method: newValue
        }
    } else if (Object.values(PAYMENT_METHOD).includes(newValue)) {
        settings.paymentMethod = newValue
    } else {
        settings.distribution = {
            pickupLocation: newValue,
            method: DELIVERY_TYPE.PICKUP,
        }
    }
}

const checkDeleteVoucher = (event: boolean): void => {
    if (event) return

    listStore.order.promoCode = undefined
}

const getTextColor = (date: DeliveryDate): string => {
    if (sameDay(DateTime.now(), date.date)) return pink
    if (date.selectable && (!date.available || date.type === DELIVERY_DATE_TYPE.WEEKEND)) return greyText
    return 'var(--ion-color-purple)'
}

const getBackgroundColor = (date: DeliveryDate): string => {
    if (date.type === DELIVERY_DATE_TYPE.HOLIDAY) return palePink
    return 'transparent'
}

const parseDateHighlights = async () => {
    const parsedDates: IonHighlightDate[] = []
    if (!supplierStore.deliveryDays[props?.cartData?.supplier?.id]) await supplierStore.getSupplierDeliveryDays(locationId.value, props.cartData.supplier.id)

    for (const deliveryDay of supplierStore.deliveryDays[props.cartData.supplier.id]) {
        parsedDates.push({
            date: deliveryDay.date,
            textColor: getTextColor(deliveryDay),
            backgroundColor: getBackgroundColor(deliveryDay)
        })
    }
    highlightDeliveryDays.value = parsedDates

    if (enablePickup()) {
        const parsedPickupDates: IonHighlightDate[] = []
        if (!supplierStore.pickupDays[props?.cartData?.supplier?.id]) await supplierStore.getSupplierPickupDays(locationId.value, props.cartData.supplier.id)

        for (const pickupDay of supplierStore.pickupDays[props.cartData.supplier.id]) {
            parsedPickupDates.push({
                date: pickupDay.date,
                textColor: getTextColor(pickupDay),
                backgroundColor: getBackgroundColor(pickupDay)
            })
        }
        highlightPickupDays.value = parsedPickupDates;
    }    
}

const trackOrder = () => {
    sentryTrack({
        message: 'User order',
        userId: useUserStore().sessionInfo.id,
        extra: {
            deliveryDate: listStore.order.deliveryDate
        }
    })
    emit('next')
}

onDeactivated(() => {
    today.value = DateTime.now().toFormat('yyyy-MM-dd').toString()
    voucher.value = ''
    redeemVoucher.value = false
    paymentOptions.splice(0)
    pickupOptions.splice(0)
    deliveryOptions.splice(0)
})

onActivated(() => {
    switch (props.cartData.supplier.paymentOptions) {
        case PAYMENT_OPTIONS.ON_ACCOUNT_OR_CASH:
            Object.assign(paymentOptions, [
                {
                    value: PAYMENT_METHOD.CASH,
                    text: t('label.cash')
                },
                {
                    value: PAYMENT_METHOD.ON_ACCOUNT,
                    text: t('label.onAccount')
                }
            ])
            break;
        case PAYMENT_OPTIONS.ON_ACCOUNT:
            Object.assign(paymentOptions, [{ value: PAYMENT_METHOD.ON_ACCOUNT, text: t('label.onAccount') }])
            break;
        case PAYMENT_OPTIONS.CASH:
            Object.assign(paymentOptions, [{ value: PAYMENT_METHOD.CASH, text: t('label.cash') }])
            break;
        default:
            listStore.order.paymentMethod = PAYMENT_METHOD.UNSPECIFIED
            break;
    }

    if (enableDelivery()) deliveryOptions.push({
        text: t('messages.order.delivery'),
        value: DELIVERY_TYPE.DELIVERY
    })
    if (enablePickup()) deliveryOptions.push({
        text: t('messages.order.pickup'),
        value: DELIVERY_TYPE.PICKUP
    })

    parseDateHighlights()

    const supplierSettings = useSupplierStore().supplierById(props.cartData.supplier.id)?.settings

    if (supplierSettings) {
        listStore.order.paymentMethod = supplierSettings.paymentMethod ?? PAYMENT_METHOD.UNSPECIFIED
        if (supplierSettings.distribution) {
            if (supplierSettings.distribution.pickupLocation) {
                listStore.order.pickupLocation = supplierSettings.distribution.pickupLocation
            }
        }
    }

    if (!listStore.order.selectedDeliveryType && deliveryOptions.length > 0)
        listStore.order.selectedDeliveryType = deliveryOptions[0].value

    if (!props.cartData.supplier.pickupLocations) return
    if (props.cartData.supplier.pickupLocations.length === 1) listStore.order.pickupLocation = props.cartData.supplier.pickupLocations[0]
    for (const location of props.cartData.supplier.pickupLocations) {
        pickupOptions.push({ text: location, value: location })
    }
})

import { isPlatform } from "@ionic/core";

const ionDateWheelHighlight = computed(() => isPlatform('android') ? '#ffdbea' : '')
const ionDateBorder = computed(() => isPlatform('android') ? '1px solid var(--ion-color-grey3-tint)' : '')
</script>

<style scoped lang="scss">
@use '@/theme/mixin.scss';

ion-datetime::part(calendar-day disabled) {
    opacity: 0.2;
}

ion-datetime::part(calendar-day today disabled) {
    opacity: 0.6;
}

ion-datetime::part(month-year-button) {
	color: var(--ion-color-coral);
}

ion-datetime {
	--ion-color-step-500: black;
	--ion-color-step-300: dimgray !important;
}

ion-datetime::part(time-button) {
	--ion-color-step-300: var(--ion-color-grey3);
}

ion-datetime { /* only on android */
	--wheel-fade-background-rgb: 255, 255, 255;
	--wheel-highlight-background: v-bind(ionDateWheelHighlight);
	border: v-bind(ionDateBorder);
}

@media (min-width: 500px) and (min-height: 500px) {
    .unset-max-width {
		max-width: unset;
	}
}

@media (orientation: landscape) and (min-height: 500px) {
    .unset-max-width {
		max-width: unset;
	}
}

.order-filter-month {
    border-radius: 16px;

    @include mixin.light {
        --background: var(--ion-color-light);
        --ion-color-step-150: transparent;
    }

    @include mixin.dark {
        --background: var(--ion-color-purple);
        --ion-color-step-150: transparent;
    }
}

.max-length {
    border: 1px solid var(--ion-color-danger);
}
</style>
